const DEFAULT_TTL_MS = 5 * 60 * 1000; // 5 minutes

const store = new Map();

/**
 * In-memory session cache for API fetch results.
 * Keys are strings; values expire after ttlMs.
 */
const apiCache = {
  get(key) {
    const entry = store.get(key);
    if (!entry) return undefined;
    if (Date.now() > entry.expiresAt) {
      store.delete(key);
      return undefined;
    }
    return entry.data;
  },

  set(key, data, ttlMs = DEFAULT_TTL_MS) {
    store.set(key, {
      data,
      expiresAt: Date.now() + ttlMs,
    });
    return data;
  },

  /**
   * Invalidate an exact key, or all keys that start with keyOrPrefix
   * when keyOrPrefix ends with ':' or '*'.
   * Examples:
   *   invalidate('clubes')
   *   invalidate('hijos:')  // all hijos:* keys
   *   invalidate('hijos:*') // same
   */
  invalidate(keyOrPrefix) {
    if (!keyOrPrefix) return;

    const isPrefix =
      keyOrPrefix.endsWith(':') || keyOrPrefix.endsWith('*');
    const prefix = keyOrPrefix.endsWith('*')
      ? keyOrPrefix.slice(0, -1)
      : keyOrPrefix;

    if (!isPrefix) {
      store.delete(keyOrPrefix);
      return;
    }

    for (const key of store.keys()) {
      if (key.startsWith(prefix)) {
        store.delete(key);
      }
    }
  },

  clear() {
    store.clear();
  },
};

export const CACHE_TTL = {
  LIST: 5 * 60 * 1000, // giras, clubes
  USER: 3 * 60 * 1000, // hijos, amateur profile
  INS: 2 * 60 * 1000, // inscriptions
};

export default apiCache;
